import { endPoints, requestType } from "../lib/Variable";
import Api from "./index";

const updateLegalContent = (id, data) => {
  return Api(
    endPoints.updateLegalContent.replace(":id", id),
    data,
    requestType.PUT,
  );
};

const getLegalContentByType = (type) => {

  return Api(
    endPoints.getLegalContentByType.replace(":type", type),
    null,
    requestType.GET,
  );
};

export { updateLegalContent, getLegalContentByType };
